/**
 * shadcn/ui Input on the brand tokens. Author: Mahmoud Ragab Ahmed.
 */
import { cn } from "@/lib/utils";

export const fieldControl = [
  "w-full min-w-0 rounded-md border border-input bg-card px-3 text-base text-foreground",
  "placeholder:text-muted-foreground transition-[border-color] duration-200",
  "hover:border-edge-hover disabled:cursor-not-allowed disabled:text-muted-foreground",
  "aria-invalid:border-danger",
].join(" ");

export function Input({
  className,
  type,
  ...props
}: React.ComponentProps<"input">): React.JSX.Element {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        fieldControl,
        "min-h-11 py-2",
        "file:me-3 file:rounded-md file:border file:border-rule-strong file:bg-transparent file:px-3 file:py-1 file:text-sm file:text-foreground",
        className,
      )}
      {...props}
    />
  );
}
